import { render, staticRenderFns } from "./pay-3.vue?vue&type=template&id=2bcc95ea&scoped=true&"
import script from "./pay-3.vue?vue&type=script&lang=js&"
export * from "./pay-3.vue?vue&type=script&lang=js&"
import style0 from "./pay-3.vue?vue&type=style&index=0&id=2bcc95ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc95ea",
  null
  
)

export default component.exports